module.exports = __webpack_public_path__ + "img/result_ls_ceil.5f3b98ad.jpg";